export const VALIDATION_TYPES = {
  submit: "submit",
  change: "change",
  focusout: "focusout",
  input: "input",
};
